import React, { Suspense, lazy } from 'react';
import { Box, Container, Spinner, Center } from '@chakra-ui/react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { StatsSection } from '../components/StatsSection';
import { Footer } from '../components/Footer';
import { BackToTop } from '../components/BackToTop';
import { SkipLink } from '../components/SkipLink';
// Lazy load below-the-fold sections
const AboutSection = lazy(() => import('../components/AboutSection').then(m => ({
  default: m.AboutSection
})));
const ToolsSection = lazy(() => import('../components/ToolsSection').then(m => ({
  default: m.ToolsSection
})));
const ProjectsSection = lazy(() => import('../components/ProjectsSection').then(m => ({
  default: m.ProjectsSection
})));
const HonorableMentions = lazy(() => import('../components/HonorableMentions').then(m => ({
  default: m.HonorableMentions
})));
const ContactSection = lazy(() => import('../components/ContactSection').then(m => ({
  default: m.ContactSection
})));
const LoadingFallback = () => <Center py={12} data-id="element-159">
    <Spinner size="xl" color="blue.500" thickness="4px" data-id="element-160" />
  </Center>;
export function Home() {
  return <Box width="100%" data-id="element-161">
      <SkipLink data-id="element-162" />
      <Navigation data-id="element-163" />
      <Header data-id="element-164" />
      <Box as="main" role="main" id="main-content" data-id="element-165">
        <StatsSection data-id="element-166" />
        <Suspense fallback={<LoadingFallback data-id="element-168" />} data-id="element-167">
          <AboutSection data-id="element-169" />
        </Suspense>
        <Container maxW="container.xl" py={8} data-id="element-170">
          <Suspense fallback={<LoadingFallback data-id="element-172" />} data-id="element-171">
            <ToolsSection data-id="element-173" />
          </Suspense>
          <Suspense fallback={<LoadingFallback data-id="element-175" />} data-id="element-174">
            <ProjectsSection data-id="element-176" />
          </Suspense>
          <Suspense fallback={<LoadingFallback data-id="element-178" />} data-id="element-177">
            <HonorableMentions data-id="element-179" />
          </Suspense>
        </Container>
        <Suspense fallback={<LoadingFallback data-id="element-181" />} data-id="element-180">
          <ContactSection data-id="element-182" />
        </Suspense>
      </Box>
      <Footer data-id="element-183" />
      <BackToTop data-id="element-184" />
    </Box>;
}